// extracted by mini-css-extract-plugin
export var container = "_61-0";
export var error = "_61-9";
export var label = "_61-5";
export var light = "_61-6";
export var md = "_61-3";
export var sm = "_61-2";
export var thin = "_61-8";
export var thinBold = "_61-7";
export var vertical = "_61-4";
export var xs = "_61-1";